export default "20260422.1 \r\n"